// Invisible time-warp utilities for local debug only
// No UI, only programmatic access via window.__rl.timewarp API

export const MS_DAY = 24 * 60 * 60 * 1000;
const KEY = "rl_time_offset_ms_v1"; // stores an integer offset in ms

export function getOffset() {
  try {
    const v = parseInt(localStorage.getItem(KEY) || "0", 10);
    return isNaN(v) ? 0 : v;
  } catch {
    return 0;
  }
}

export function setOffset(ms) {
  try { localStorage.setItem(KEY, String(ms)); } catch {}
  // Notify listeners
  try { window.dispatchEvent(new CustomEvent("rl-timewarp-changed", { detail: { offset: ms } })); } catch {}
}

export function addOffset(deltaMs) {
  const next = getOffset() + deltaMs;
  setOffset(next);
  return next;
}

export function resetOffset() { setOffset(0); }

export function getNow() {
  return Date.now() + getOffset();
}

export function advanceDays(days) { return addOffset(days * MS_DAY); }
export function advanceWeeks(weeks) { return addOffset(weeks * 7 * MS_DAY); }
export function advanceThirtyDays() { return addOffset(30 * MS_DAY); }
export function advanceYearPlus() { return addOffset(367 * MS_DAY); }

// Expose hidden debug API (no visible UI)
try {
  if (typeof window !== "undefined") {
    window.__rl = window.__rl || {};
    window.__rl.timewarp = Object.freeze({
      getOffset,
      setOffset,
      addOffset,
      resetOffset,
      getNow,
      advance1d: () => advanceDays(1),
      advance7d: () => advanceWeeks(1),
      advance30d: advanceThirtyDays,
      advance367d: advanceYearPlus,
    });
  }
} catch {}